import { clamp, easeOutCubic, glow, mulberry32, TAU, type DrawFn } from '../lib/math'

export function createSovereign(): DrawFn {
  const rng = mulberry32(273)
  const leaves = Array.from({ length: 70 }, () => ({
    x: 0.32 + rng() * 0.36,
    y: rng(),
    w: 5 + rng() * 11,
    h: 3 + rng() * 7,
    rot: rng() * TAU,
    spin: (rng() - 0.5) * 1.6,
    speed: 18 + rng() * 38,
    sway: 8 + rng() * 16,
    o: rng() * TAU,
    shine: rng(),
  }))

  return (ctx, t, w, h) => {
    ctx.clearRect(0, 0, w, h)
    const intro = easeOutCubic(clamp(t / 1.1))
    const cx = w * 0.5

    // light shaft
    const shaft = ctx.createLinearGradient(cx, 0, cx, h)
    shaft.addColorStop(0, `rgba(255,220,140,${0.16 * intro})`)
    shaft.addColorStop(0.45, `rgba(232,200,114,${0.07 * intro})`)
    shaft.addColorStop(1, 'rgba(232,200,114,0)')
    ctx.fillStyle = shaft
    ctx.beginPath()
    ctx.moveTo(cx - 28, 0)
    ctx.lineTo(cx + 28, 0)
    ctx.lineTo(cx + w * 0.18, h)
    ctx.lineTo(cx - w * 0.18, h)
    ctx.closePath()
    ctx.fill()

    ctx.globalCompositeOperation = 'lighter'
    glow(ctx, cx, h * 0.08, 90, `rgba(255,220,150,${0.22 * intro})`)

    for (const L of leaves) {
      const y = ((L.y * h + t * L.speed) % (h + 40)) - 20
      const x = L.x * w + Math.sin(t * 0.8 + L.o) * L.sway
      const rot = L.rot + t * L.spin
      const catchLight = 0.45 + 0.55 * Math.abs(Math.sin(rot * 2 + L.shine))
      ctx.save()
      ctx.translate(x, y)
      ctx.rotate(rot)
      ctx.globalAlpha = intro * (0.45 + catchLight * 0.55)
      const g = ctx.createLinearGradient(-L.w, 0, L.w, 0)
      g.addColorStop(0, '#7a5a18')
      g.addColorStop(0.45, '#f0d78a')
      g.addColorStop(1, '#c9a227')
      ctx.fillStyle = g
      ctx.beginPath()
      ctx.moveTo(0, -L.h)
      ctx.lineTo(L.w, 0)
      ctx.lineTo(0, L.h)
      ctx.lineTo(-L.w * 0.7, 0)
      ctx.closePath()
      ctx.fill()
      ctx.restore()
    }

    ctx.globalCompositeOperation = 'source-over'
  }
}
